module.exports = __webpack_public_path__ + "media/images/gallery/constellations/oc_layer_on-baf1a039564affc8b1558bfdfff44635.png";